import React from 'react';

import { TournamentsMenuLayerItem } from '../../types';
import { MENU_ITEM_TYPE } from 'app/modules/Navigation/types';

import {
  createPriorityGroupDelimiterClassGetter,
} from '../../styles/menu-item-priority-group-styles';
import PromotedMenuItem from '../TournamentsMenuItems/PromotedMenuItem';
import TournamentMenuItem from './TournamentMenuItem';

import styles from '../../styles/LeftMenu.module.scss';

type SportTournamentsMenuItemsProps = {
  list: TournamentsMenuLayerItem[];
};

const SportTournamentsMenuItems: React.FC<SportTournamentsMenuItemsProps> = ({ list }) => {
  const getPGDClassName = createPriorityGroupDelimiterClassGetter();

  return (
    <ul className={styles.layerMenuItems}>
      {list.map((item) => {
        if (item.type !== MENU_ITEM_TYPE.TOURNAMENT) {
          return (
            <PromotedMenuItem
              entry={item}
              key={item.key} />
          );
        }

        return (
          <TournamentMenuItem
            entry={item}
            className={getPGDClassName(item.priority)}
            key={item.key} />
        );
      })}
    </ul>
  );
};

export default SportTournamentsMenuItems;
